import React from "react";
import Navbar from "../components/Navbar5";
import HeroSection from "../components_about/HeroSection2";
import Footer from "../components/Footer1";
import CompanySnapshot from "../components_about/CompanySnapshot";
import AboutTrustSection from "../components_about/AboutTrustSection";
import SEO from "../components/SEO";

const aboutPageSchema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  name: "About VishvaConnect Technologies LLP",
  url: "https://www.vishvaconnect.com/about",
  description:
    "Learn about VishvaConnect Technologies LLP, a software development company delivering government portals, business automation, websites, dashboards and custom software solutions.",
  mainEntity: {
    "@type": "Organization",
    name: "VISHVACONNECT TECHNOLOGIES LLP",
    url: "https://www.vishvaconnect.com/",
    email: "vishvaconnect7@gmail.com",
    sameAs: [
      "https://www.linkedin.com/company/vishvaconnect/",
      "https://www.youtube.com/@VishvaConnect",
    ],
  },
};

function AboutPage() {
  return (
    <>
      <SEO
        title="About VishvaConnect Technologies LLP | Software Company"
        description="Learn about VishvaConnect Technologies LLP, our experience in custom software development, government portals, websites, automation and digital solutions."
        path="/about"
        schema={aboutPageSchema}
      />
      <Navbar />

      <main>
        <HeroSection />
        <CompanySnapshot />
        <AboutTrustSection />
      </main>

      <Footer />
    </>
  );
}

export default AboutPage;
